<div class="basic-feed-item {{ type }}">
  <div class="left-contents">
    <div *ngIf="identifier" class="identifier">
      <div class="text-wrapper">
        <span class="text">
          {{ identifier }}
        </span>
      </div>
    </div>

    <div
      class="content"
      [ngClass]="{
        'separate-header-description': separateHeaderAndDescription
      }"
    >
      <div *ngIf="header" class="header-wrapper">
        <span class="header text">
          {{ header }}
        </span>

        <span *ngIf="headerIcon" class="header-icon-wrapper">
          <app-icon [icon]="headerIcon"></app-icon>
        </span>
      </div>

      <div
        *ngIf="description || subDescription || descriptionIcon"
        class="info"
      >
        <app-icon
          *ngIf="descriptionIcon"
          class="description-icon"
          [icon]="descriptionIcon"
        >
        </app-icon>

        <span
          *ngIf="description"
          [multiLineTruncate]="descriptionTruncateThreshold"
          class="description text"
        >
          {{ description }}
        </span>

        <span
          *ngIf="subDescription"
          [multiLineTruncate]="subDescriptionTruncateThreshold"
          class="sub-description text"
        >
          {{ subDescription }}
        </span>
      </div>
    </div>
  </div>

  <div
    class="right-contents"
    *ngIf="
      metadataHeader ||
      !!metadataDescription ||
      !!primaryActionText ||
      deletable
    "
  >
    <div class="metadata-actions-wrapper">
      <div *ngIf="metadataHeader" class="metadata-header-wrapper">
        <span class="metadata-header text">
          {{ metadataHeader }}
        </span>
      </div>

      <div
        *ngIf="metadataDescription || !!primaryActionText || deletable"
        class="metadata-description-actions-wrapper"
      >
        <div class="actions">
          <button
            *ngIf="primaryActionText"
            type="button"
            class="action primary-action"
            (click)="onPrimaryActionClick($event)"
          >
            {{ primaryActionText }}
          </button>

          <button
            *ngIf="secondaryActionText || deletable"
            type="button"
            [ngClass]="{ 'delete-action': deletable }"
            class="action secondary-action"
            (click)="onSecondaryActionClick($event)"
          >
            {{ secondaryActionText || ('ACTION.DELETE' | translate) }}
          </button>
        </div>

        <div *ngIf="metadataDescription" class="metadata-description-wrapper">
          <span class="metadata-description text">
            {{ metadataDescription }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
